/* eslint-disable padding-line-between-statements */
/* eslint-disable arrow-body-style */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-param-reassign */
import React, {
    useContext, useState, useEffect, useCallback
} from 'react';

import { ViewModelServiceContext, ViewModelForm, useDataRefresh } from '@xengage/gw-portals-viewmodel-react';
import { FormattedMessage, useTranslator } from '@jutro/locale';
import PropTypes from 'prop-types';
import { Tooltip, useModal } from '@jutro/components';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { useAuthentication } from '@xengage/gw-digital-auth-react';
import { UserService } from 'gw-capability-gateway';
import { LoadSaveService } from 'gw-capability-gateway-quoteandbind';
import { MLInsuredCandidatesComponent, MLPAEditDriverComponent } from 'ml-components-common-react';

import { MLDriverVehicleUtil, MLAvailableInsuredCandidatesUtil, MLWizardNavUtil } from 'ml-portals-util-react';
import { MLMultiLobsDataHolderService, MLBundleService } from 'ml-services-common-react';
import { FormModalPopover, platformMessages } from 'ml-components-platform-react';
import { MLDisclosureUtil } from 'ml-portals-util-js';
import { MLModalService, MLTagManagerService } from 'ml-portals-services-react';
import _ from 'lodash';

import classNames from 'classnames';
import appConfig from 'app-config';
import { Button } from '@jutro/legacy/components';
import { withRouter } from 'react-router-dom';
import {MLQuoteFlowUtil} from "ml-portals-util-js";
import { ScrollToError } from '@jutro/legacy/wizard-next';
import PATrackEvent from 'gw-capability-gateway-quoteandbind-common-react/components/TrackEvent/PATrackEvent';
import metadata from './GatewayDriversPage.metadata.json5';
import messages from './GatewayDriversPage.messages';
import styles from './GatewayDriversPage.module.scss';
import removeDriverMessages from './RemoveDriverPopup.messages';
import removeDriverMetadata from './RemoveDriverPopup.metadata.json5';
import removeDriverModalBodyStyles from './RemoveDriverPopup.module.scss';
import moment from 'moment';

const ACTION_ADD_DRIVER = 'add';
const ACTION_REMOVE_DRIVER = 'remove';

// edge/agent/.../MLPADriverDetailsCtrl.js, ml-pa-driver-details.html
function MetadataTooltip({ children }) {
    const translator = useTranslator();
    const child = Array.isArray(children) ? children[0] : children;
    const renderingContent = (header, content) => {
        return (
            <React.Fragment>
                <h3 className={styles['tooltip-header']}>
                    {header}
                </h3>
                <div>
                    {content}
                </div>
            </React.Fragment>
        );
    };

    return (
        <Tooltip
            id="metadataTooltip"
            placement="bottom"
            trigger="click"
            content={
                renderingContent(
                    translator(removeDriverMessages.RemoveDriverExclusionHelpTitle),
                    translator(removeDriverMessages.RemoveDriverExclusionHelpText)
                )
            }
        >
            {child}
        </Tooltip>
    );
}
MetadataTooltip.propTypes = {
    children: PropTypes.shape({}).isRequired
};


function GatewayDriversPage(props) {
    const modalApi = useModal();
    //
    // common component defs
    //
    const {
        wizardData: submissionVM, updateWizardData, goNext, updateWizardSnapshot, isSkipping, currentStep, steps, history
    } = props;
    const viewModelService = useContext(ViewModelServiceContext);
    const translator = useTranslator();
    const { authHeader } = useAuthentication();
    const { refreshData } = useDataRefresh();
    const {
        // initialValidation,
        onValidate,
        isComponentValid,
        initialValidation
    } = useValidation('GatewayDriversPage');
    const [showValidtionErrors, setShowValidtionErrors] = useState(false);
    const [errorTimestamp, setErrorTimestamp] = useState(0);
    const isModernProduct = _.get(submissionVM, 'isModernProduct_Ext.value', false);

    const {nextStepVisited, isLastStep} = MLWizardNavUtil(props);

    const {
        showProgressDialog,
        hideProgressDialog
    } = MLModalService();

    const {
        validateDriverRemoval,
        isDriverRemovalAddHouseholdMember,
        isDriverRemovalExclusion,
        isDriverRemovalAddRatedDriver,
        checkUniqueSelf,
        checkUniqueSpouse,
        unobtainableDriverLicense,
        displayUnobtainableDriverLicenseMessage,
        clearUnobtainableDriverLicenseMessage,
        setDriversForFullAddition,
        setDefaultStatusForRatedDriver,
        displayNonAccidentPreventionModifierMessage,
        setModifierEditMode,
        isAccidentPreventionCourse,
        setSpousesForDriver,
        getRemoveDriverExcludedOptions,
        getModernProductRemoveDriverOptions,
        getHouseholdNonDriverType,
        checkIfNonDriver
    } = MLDriverVehicleUtil();

    const {
        filterAvailableAutoInsuredCandidates,
        addRemovedDriverToAvailableCandidates
    } = MLAvailableInsuredCandidatesUtil();

    const { returnToQuoteScreen } = MLQuoteFlowUtil();
    const { canShowReturnToQuoteButton } = MLWizardNavUtil(props);

    //
    // constants
    //
    const driverTypeTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverType_ML');
    const statusTypelist = viewModelService.productMetadata.get('pc').types.getTypelist('DriverStatusType_ML');
    const isGPA = appConfig.portalCode === 'GPA';
    const Household = driverTypeTypelist.getCode('household').code;
    const Excluded = driverTypeTypelist.getCode('excluded').code;
    const Rated = driverTypeTypelist.getCode('rated').code;
    const NonDriver = driverTypeTypelist.getCode('nondriver').code;
    const OutOfHousehold = driverTypeTypelist.getCode('outofhousehold').code;
    const Permitted = driverTypeTypelist.getCode('permitted').code;

    const NotInHousehold = statusTypelist.getCode('not_household').code;
    const DuplicateDriver = statusTypelist.getCode('duplicate_driver_ml').code;
    const UnknownDriver = statusTypelist.getCode('unknown').code;
    const NotResiding = statusTypelist.getCode('notresiding').code;
    const Deceased = statusTypelist.getCode('deceased').code;
    const SELF_TAG = 'self';
    const SPOUSE_TAG = 'spouse';
    const directRemoveStatuses = ['unknown', 'not_household', 'notresiding'];
    //
    // initialize state
    //
    const paModelVal = _.get(submissionVM, 'lobData.personalAuto.coverables.value', {});
    const driversVMPath = 'lobData.personalAuto.coverables.drivers';

    const [unobtainableDriverLicenseDisplayed, setUnobtainableDriverLicenseDisplayed] = useState(false);
    const [nonAccidentPreventionDisplayed, setNonAccidentPreventionDisplayed] = useState(false);

    const [insuredCandidateComponentVisibleML, setInsuredCandidateComponentVisibleML] = useState(false);
    const [insuredCandidateSelectedML, setInsuredCandidateSelectedML] = useState(true);
    const [initDriverPublicIDML, setInitDriverPublicIDML] = useState(undefined);
    const [validationErrorMessage, setValidationErrorMessage] = useState(false);
    const [showValidationError, setShowValidationError] = useState(false);

    const DRIVER_TAB_ID = 'driverTab-';

    const [selectedDriverIndex, setSelectedDriverIndex] = useState(0);
    const [alerts, setAlerts] = useState([]);
    const [showReturnToQuote, setShowReturnToQuote] = useState(false);
    const quoteStep = steps.find((step) => step.mlStepName === 'quoteDetails');
    const [canRequote, setCanRequote] = useState(false);
    const ACCOUNTHOLDER_MIN_AGE = 18;

    const policyStateCode = submissionVM.baseData.policyAddress.state.value.code;
    const isStateND = (state) => state === 'ND';
    const isStateMD = (state) => state === 'MD';

    // all drivers
    const driverList = _.get(submissionVM, `${driversVMPath}.value`, []);

    const setCanRequoteFlag = useCallback ( async() => {
        setCanRequote(showReturnToQuote && _.get(quoteStep, 'visited') !== true);
    }, [quoteStep, showReturnToQuote]);

    const unsortedratedDriverVMList = driverList.filter((driver) => {
        return driver.type_ML !== Excluded && driver.type_ML !== Household && driver.type_ML !== NonDriver
            && driver.type_ML !== OutOfHousehold && driver.type_ML !== Permitted;
    }).map((driver) => {
        return submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(driver);
    });

    // display only rated drivers
    const ratedDriverVMList = _.sortBy(unsortedratedDriverVMList, (driver) => {
        if (driver.publicID && driver.publicID.value) {
            return _.toInteger(driver.publicID.value.split(':')[1]); 
        }
        return undefined;
    });
    const ratedDriverList = ratedDriverVMList.map((d) => d.value);
    const selectedDriverVM = ratedDriverVMList[selectedDriverIndex];
    const activeDriverTab = `${DRIVER_TAB_ID}${selectedDriverIndex}driversIterable`;

    setDriversForFullAddition(ratedDriverList);
    setModifierEditMode(ratedDriverList, true);

    const isFinalDriver = () => {
        return selectedDriverIndex === (ratedDriverList.length - 1);
    };

    useEffect(() => {
        if (isGPA && !isSkipping) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Reached', isSkipping, submissionVM, user, { step: 'Drivers Screen', ratedDriverList: ratedDriverList });
            });
        }
        canShowReturnToQuoteButton(submissionVM, authHeader, quoteStep).then((response) => {
            setShowReturnToQuote(!!response);
        });
        if(currentStep.mlStepName === "paDriverDetails" || currentStep.mlStepName === "compPaDrivers"){
            const drivers = submissionVM?.value?.lobData?.personalAuto?.coverables?.drivers;
            if (Array.isArray(drivers)) {
                const targetCodes = [
                    "PADriverSignalProgramPhoneNumber_Ext"
                ];

                 drivers.forEach((driver) => {
                    const modifiers = driver?.driverModifiers_ML?.modifiers;
                    if (Array.isArray(modifiers)) {
                        modifiers.forEach((modifier) => {
                            if (modifier && targetCodes.includes(modifier.codeIdentifier_ML)) {
                                modifier.chosenTermValue = null;
                                modifier.isVisible_ML = false
                                modifier.isInputValueRequired_ML = false
                                modifier.editMode_ML = false
                                modifier.savedFromPortal = false
                            }
                        });
                    }
                    driver.isLicenseNumberRequired_ML = false;
                });
            }
        }
    }, []);

    // prefill occupation for primary driver. only need check once.
    useEffect(() => {
        const quoteID = submissionVM.quoteID.value;
        const primaryDriver = driverList.find((d) => d.relationshipToInsured_ML === 'self');
        if (!primaryDriver) {
            const notExcludedDriverVMList = driverList.filter((driver) => {
                return driver.type_ML !== Excluded;
            }).map((driver) => {
                return submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(driver);
            });
            notExcludedDriverVMList[0].relationshipToInsured_ML = 'self';
        }

        setDefaultStatusForRatedDriver(ratedDriverList);

        if (submissionVM.isBundle_ML.value && primaryDriver && _.isUndefined(primaryDriver.occupation_Ext)) {
            const prefillCandidate = MLBundleService.getPrefillCandidateForJobType(quoteID, 'PA');
            if (prefillCandidate) {
                primaryDriver.occupation_Ext = prefillCandidate.occupationType;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        setTimeout(()=>{
            const element = document.getElementsByClassName("jut__TabBar__heading app__GatewayDriversPage__tab active")[0];
            if(element){
                element.focus();
            }
        }, 100)
    }, []);

    useEffect(() => {
        setCanRequoteFlag();
    }, [setCanRequoteFlag, submissionVM]);

    //
    // define page
    //
    const disableEditModeIfNonRated = (driver) => {
        if (driver.type_ML === Household || driver.type_ML === Excluded) {
            driver.editMode_ML = false;
        }
    };

    const addAlert = (driver, message, helpText, alertType) => {
        setAlerts([{
            object: driver ? driver.person.getDisplayName() : undefined,
            message,
            helpText, // optional
            type: alertType || 'success',
            undo: () => {
                if (!driver.status_ML || driver.status_ML === NotInHousehold || driver.status_ML === DuplicateDriver 
                    || driver.status_ML === UnknownDriver || driver.status_ML === NotResiding || driver.status_ML === Deceased) {
                    // If the driver was totally removed, restore it.
                    driver.fixedId = null; // after being totally removed, this is no longer valid
                    submissionVM.lobData.personalAuto.coverables.drivers.pushElement(driver);
                } else {
                    // Otherwise, the driver still exists and just needs to be re-typed as rated.
                    const undoDriverNode = submissionVM.lobData.personalAuto.coverables.drivers.findFirstElement(driver);
                    undoDriverNode.type_ML = Rated;
                }
                setAlerts([]);
            }
        }]);
    };

    //
    // Modifier
    //
    const disableValidationForDependentModifiers = (mod) => {
        if (mod && mod.hasDependentModifier_ML.value) {
            ratedDriverList.forEach((driver) => {
                if (!_.isEmpty(driver.driverModifiers_ML)) {
                    driver.driverModifiers_ML.modifiers.forEach((modifier) => {
                        if (modifier.isDependentModifier_ML) {
                            modifier.editMode_ML = false;
                        }
                    });
                }
            });
        }
    };

    const setIsSchoolAddressRequired = (submissionVM) => {
        const driversVM = _.get(submissionVM, driversVMPath)
        driversVM.value.forEach(driver => {
            driver.isSchoolAddressRequired_Ext = driver?.driverModifiers_ML?.modifiers.some(d =>
                d.codeIdentifier_ML === "PADistantStudent_Ext" &&
                d.chosenTermValue === "true"
            ) ?? false;
        });
    }

    const updateModifiers = (mod) => {
        const setEditMode = (editMode) => submissionVM.value.lobData.personalAuto.coverables.drivers.forEach((driver) => {
            driver.editMode_ML = editMode;
            driver.isSchoolAddressRequired_Ext = editMode;
            driver.schoolAddress_Ext = undefined;
        });

        disableValidationForDependentModifiers(mod);

        // Disable validation so we can update the model and the driver modifiers with it
        setEditMode(false);
        if (currentStep.mlStepName === 'compPaDrivers') {
            _.set(submissionVM, 'bypassValidationForComprater_Ext', true);
            setIsSchoolAddressRequired(submissionVM)
        }

        const submissionLoadPromise = LoadSaveService.updateModifiers(submissionVM.value, authHeader);
        showProgressDialog(platformMessages.syncing, submissionLoadPromise, true);
        submissionLoadPromise.then((qdd) => {
            submissionVM.value.lobData.personalAuto.coverables.drivers.length = 0;
            const sortedDrivers = _.sortBy(qdd.lobData.personalAuto.coverables.drivers, (driver) => {
                if (driver.publicID) {
                    return _.toInteger(driver.publicID.split(':')[1]);
                }
                return undefined;
            });
            sortedDrivers.forEach((driver) => {
                if (driver.person) {
                    driver.person = submissionVM.value.findPerson(submissionVM.value, driver.person);
                }
            });
            _.set(submissionVM, 'value.lobData.personalAuto.coverables.drivers', sortedDrivers);
            setSpousesForDriver(driverList);
            // setPage({ ...page, currentDriverVM: ratedDriverVMList[page.currentIdx] });
            if(currentStep.mlStepName === "paDriverDetails" || currentStep.mlStepName === "compPaDrivers"){
                const drivers = submissionVM?.value?.lobData?.personalAuto?.coverables?.drivers;
                if (Array.isArray(drivers)) {
                    const targetCodes = [
                        "PADriverSignalProgramPhoneNumber_Ext"
                    ];

                    drivers.forEach((driver) => {
                        const modifiers = driver?.driverModifiers_ML?.modifiers;
                        if (Array.isArray(modifiers)) {
                            modifiers.forEach((modifier) => {
                                if (modifier && targetCodes.includes(modifier.codeIdentifier_ML)) {
                                    modifier.chosenTermValue = null;
                                    modifier.isVisible_ML = false
                                    modifier.isInputValueRequired_ML = false
                                    modifier.editMode_ML = false
                                    modifier.savedFromPortal = false
                                }
                            });
                        }
                    });
                }
            }

            if (mod?.codeIdentifier_ML?.value === 'PADriverSignalProgram_Ext') {
                submissionVM.value.lobData.personalAuto.coverables.vehicles.length = 0;
                qdd.lobData.personalAuto.coverables.vehicles.forEach((updatedVehicle, index) => {
                    initVehicleValue(updatedVehicle);
                    submissionVM.value.lobData.personalAuto.coverables.vehicles.push(updatedVehicle);
                });
            }
        }, (error) => {
            console.error(error);
        }).finally(() => {
            setModifierEditMode(submissionVM.value.lobData.personalAuto.coverables.drivers, true);
            updateWizardData(submissionVM);
        });
    };

    const doesDriverExistInBackEnd = (driverVM) => {
        return !!driverVM.publicID.value || !!driverVM.person.publicID.value;
    };

    const doesDriverValExistInBackEndML = (driver) => {
        return !!driver && ((!!driver.publicID) || (!!driver.person && !!driver.person.publicID));
    };

    const initVehicleValue = (vehicle) => {
        if (!vehicle.value_ML || vehicle.value_ML.amount === 0) {
            vehicle.value_ML = {};
        }
        vehicle.tempID = (vehicle.publicID) ? vehicle.publicID : vehicle.tempID;
    };

    const onDriverTabChange = useCallback((tabId, driverRemoved = false) => {
        let driverIndex;

        if (tabId === 'addDriverTabButton') {
            MLTagManagerService.sendLinkClickEvent(`${MLTagManagerService.getStepName()}_Add Driver`);
            const newDriver = paModelVal.createDriver();
            newDriver.person.primaryAddress = submissionVM.baseData.policyAddress.value;
            newDriver.licenseState = newDriver.person.primaryAddress.state;
            newDriver.type_ML = Rated;
            newDriver.editMode_ML = true;
            driverIndex = ratedDriverList.length;
            setAlerts([]);
            
            setInsuredCandidateComponentVisibleML(true);
            setInsuredCandidateSelectedML(false);
            setInitDriverPublicIDML(undefined);
        } else {
            const indexOfNumber = tabId.indexOf('-') + 1;

            driverIndex = _.toInteger(tabId.substring(indexOfNumber, tabId.indexOf('driversIterable')));

            if (driverRemoved && driverIndex >= ratedDriverList.length - 1) {
                driverIndex--;
            }

            const currDriver = ratedDriverList[driverIndex];
            
            const insuredCandidateComponentVisibleVal = !doesDriverValExistInBackEndML(currDriver);
            setInsuredCandidateComponentVisibleML(insuredCandidateComponentVisibleVal);
            const insuredCandidateSelectedVal = !currDriver ? true : (doesDriverValExistInBackEndML(currDriver) || !!currDriver.selected);
            setInsuredCandidateSelectedML(insuredCandidateSelectedVal);
            setInitDriverPublicIDML(insuredCandidateComponentVisibleVal && insuredCandidateSelectedVal ? 'new' : undefined);
        }

        setSelectedDriverIndex(driverIndex);
        filterAvailableAutoInsuredCandidates(submissionVM, driverList);

    }, [Rated, driverList, filterAvailableAutoInsuredCandidates, paModelVal, ratedDriverList, setSelectedDriverIndex, submissionVM]);


    //
    // Remove Driver
    //
    const removeDriver = useCallback((driver, driverIndex) => {
        addRemovedDriverToAvailableCandidates(submissionVM, driver);
        driver.fixedId = null // after being totally removed, this is no longer valid
        paModelVal.removeDriver(driver);
        updateWizardData(submissionVM);
        addAlert(driver, removeDriverMessages.DriverHasBeenRemoved);

        const newIndex = driverIndex > 0 ? driverIndex - 1 : 0;
        setSelectedDriverIndex(newIndex);
        onDriverTabChange(activeDriverTab, true);
    }, [paModelVal, addRemovedDriverToAvailableCandidates, submissionVM, addAlert, onDriverTabChange, activeDriverTab]);

    const validateUniqueDriverRelationship_Ext = (driverVM, code, driversOnSubmission, message) => {
        if (driverVM.relationshipToInsured_ML && driverVM.relationshipToInsured_ML === code) {
            for (let i = 0; i < driversOnSubmission.length; i++) {
                const driver = driversOnSubmission.value[i];
                if (driver !== driverVM && driver.relationshipToInsured_ML === code) {
                    return message;
                }
            }
        }
    }

    const removeDriverButtonClick = (driverVM, driverIndex) => {
        const removeDriverModelTitle = `${translator(removeDriverMessages.remove)}`;

        if (!doesDriverExistInBackEnd(driverVM)) {
            removeDriver(driverVM.value, driverIndex);
            return;
        }

        const validateCanDriverBeRemoved_Ext = (driverToRemove) => {
            const validationResult = validateDriverRemoval(driverVM.value, submissionVM.value);
            if (!validationResult.hasError) {
                const selfOrSpouseRemovalValidationError = validateUniqueDriverRelationship_Ext(driverToRemove, SELF_TAG, _.get(submissionVM, driversVMPath, []), translator(messages.selfSelected_Ext)) 
                    || validateUniqueDriverRelationship_Ext(driverToRemove, SPOUSE_TAG, _.get(submissionVM, driversVMPath, []), translator(messages.spouseSelected_Ext));
                if (selfOrSpouseRemovalValidationError) {
                    validationResult.errorMessage = selfOrSpouseRemovalValidationError;
                    validationResult.hasError = true;
                }
            }

            return validationResult;
        }

        const disableButton = () => {
            const validationResult = validateCanDriverBeRemoved_Ext(driverVM.value);
            return validationResult.hasError;
        };

        // open dialog
        const onRemoveDriverValidation = ({ value: driverToRemove }) => {
            const validationResult = validateCanDriverBeRemoved_Ext(driverToRemove, submissionVM.value);
            return !validationResult.hasError;
        };

        const onRemoveDriver = () => {
            const driver = driverVM.value;

            if (isModernProduct && directRemoveStatuses.includes(driver.status_ML)) {
                removeDriver(driver, driverIndex);
                // removeDriverFromContactList(driver)
               paModelVal.removeDriver(driver);
               updateWizardData(submissionVM)
               addAlert(driver, removeDriverMessages.DriverHasBeenRemoved);
            }    
            else
                if (driver.status_ML === 'own_insurance' && isModernProduct) {
                    if (checkIfNonDriver(driver)) {
                        driver.type_ML = getHouseholdNonDriverType(driver, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code);
                        let msg = removeDriverMessages.DriverHasBeenAddedAsANonDriver;
                        addAlert(driver, msg);
                    } else {
                        driver.type_ML = Excluded;
                        const helpMessage = {
                            title: translator(removeDriverMessages.RemoveDriverExclusionHelpTitle),
                            message: translator(removeDriverMessages.RemoveDriverExclusionHelpText)
                        };
                        addAlert(driver, removeDriverMessages.DriverHasBeenExcluded, helpMessage);
                    }
                }
            else if (isDriverRemovalAddHouseholdMember(driver, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code)) {
                driver.type_ML = getHouseholdNonDriverType(driver, isModernProduct, submissionVM.baseData?.canExcludeDrivers_ML?.value, submissionVM.baseData.policyAddress.state.value.code);
                let msg = removeDriverMessages.DriverHasBeenAddedAsAHouseHoldMember
                if (isModernProduct) {
                    msg = removeDriverMessages.DriverHasBeenAddedAsANonDriver;
                }
                addAlert(driver, msg);
            } else if (isDriverRemovalExclusion(driver, isModernProduct)) {
                driver.type_ML = Excluded;
                const helpMessage = {
                    title: translator(removeDriverMessages.RemoveDriverExclusionHelpTitle),
                    message: translator(removeDriverMessages.RemoveDriverExclusionHelpText)
                };
                addAlert(driver, removeDriverMessages.DriverHasBeenExcluded, helpMessage);
            } else if (isDriverRemovalAddRatedDriver(driver)) {
                addAlert(undefined, removeDriverMessages.notAValidReasonToRemoveThisDriver_Ext, undefined, 'error');
            } else {
                removeDriver(driver, driverIndex);
                 addAlert(driver, removeDriverMessages.DriverHasBeenRemoved);
            }
            setSelectedDriverIndex(driverIndex > 0 ? driverIndex - 1 : 0);
            driver.editMode_ML = false;
            MLTagManagerService.sendFormStepEvent(MLTagManagerService.getFormName(), `${MLTagManagerService.getStepName()}_Remove Driver`);
        };

        const onCancelRemoveDriver = () => {
            _.set(driverVM, 'isPreparedToRemove_ML.value', false);
            _.set(driverVM, 'value.status_ML', "insure_driver");
        };

        const componentProps = {
            title: removeDriverModelTitle,
            uiProps: removeDriverMetadata.pageContent,
            viewModel: driverVM,
            actionBtnLabel: removeDriverMessages.Continue,
            cancelBtnLabel: removeDriverMessages.Cancel,
            onSaveAction: onRemoveDriverValidation,
            disableButton: disableButton,
            modalBodyStyles: removeDriverModalBodyStyles,
            discardChangesOnCancel: true,
            viewModelService,
            getOverrideProps: () => {
                const validationResult = validateCanDriverBeRemoved_Ext(driverVM.value);
                return {
                    reason: {
                        availableValues: isModernProduct ? getModernProductRemoveDriverOptions() : getRemoveDriverExcludedOptions()
                    },
                    validationErrorMessage: {
                        content: validationResult.errorMessage
                    },
                    errorNotification: {
                        visible: validationResult.hasError
                    }
                };
            }
        };

        modalApi.showModal(
            <FormModalPopover {...componentProps} />
        ).then(onRemoveDriver, onCancelRemoveDriver);
    };

    const isOnlyOneDriver = () => {
        return ratedDriverList.length === 1;
    }

    // Clean up Spouse_ML value if driver is not Married
    const cleanUpSpouseIfDriverIsUnmarried = (driver) => {
        if (driver.maritalStatus_ML !== 'M') {
            if(!_.isUndefined(driver.spouseID_ML)) {
                driver.spouseID_ML = null;
            }
        }
    };

    const validateNoAlphaNumericCharacters = (name) => {
        return name && /^[^0-9]+$/.test(name);
    };

    const isDriverFullNameNonNumeric = (driver) => {
        const isFirstNameValid = validateNoAlphaNumericCharacters(_.get(driver, 'person.firstName'));
        const isMiddleNameValid = _.get(driver, 'person.middleName') ? validateNoAlphaNumericCharacters(_.get(driver, 'person.middleName')) : true;
        const isLastNameValid = validateNoAlphaNumericCharacters(_.get(driver, 'person.lastName'));

        return isFirstNameValid && isMiddleNameValid && isLastNameValid
    }

    const goToFirstInvalidTab = () => {
        const index = ratedDriverVMList.findIndex((driver) => {
            return !driver.aspects.valid || !driver.aspects.subtreeValid || !isDriverFullNameNonNumeric(_.get(driver, 'value'));
        })

        if(index !== -1) {
            setSelectedDriverIndex(index);
        }
    };

    const getAccountHolderAge = () => {
        let accountHolderDob = _.get(submissionVM, 'baseData.accountHolder.dateOfBirth.value', "");
        let currDate = new Date();
        let accountHolderAge = moment(currDate).diff(accountHolderDob, 'years');
        return accountHolderAge;
    }

    const validateData = useCallback((isReturnToQuote = false) => {
        _.set(submissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);

        const isValid = checkUniqueSelf(driverList) && checkUniqueSpouse(driverList)
        const areDriverNamesNumeric = driverList.some(driver => !isDriverFullNameNonNumeric(driver));

        if (!isValid) {
            setShowValidtionErrors(true);
            setErrorTimestamp(errorTimestamp+1);
            return false;
        }

        if (insuredCandidateComponentVisibleML && !insuredCandidateSelectedML) {
            setValidationErrorMessage(translator(messages.selectDriver));
            setShowValidationError(true);
            window.scrollTo(0, 0);
            return false;
        }

        if(getAccountHolderAge() < ACCOUNTHOLDER_MIN_AGE){
            setValidationErrorMessage(translator(messages.accountHolderMinAge));
            setShowValidationError(true);
            window.scrollTo(0, 0);
            return false;
        }

        if (!submissionVM.lobData.personalAuto.coverables.aspects.subtreeValid || areDriverNamesNumeric) {
            if(isDriverValid(selectedDriverVM)) {
                goToFirstInvalidTab();
            }

            // Delay setting validation properties in case tab needs to change first
            setTimeout(() => {
                setShowValidtionErrors(true);
                setErrorTimestamp(errorTimestamp+1);
            }, 200)

            return false;
        }

        if (unobtainableDriverLicense(selectedDriverVM.licenseState) && !unobtainableDriverLicenseDisplayed) {
            displayUnobtainableDriverLicenseMessage(false);
            setUnobtainableDriverLicenseDisplayed(true);
            return false;
        }
        const { drivers } = submissionVM.value.lobData.personalAuto.coverables;

        if (isAccidentPreventionCourse(drivers, policyStateCode) && !nonAccidentPreventionDisplayed) {
            displayNonAccidentPreventionModifierMessage();
            setNonAccidentPreventionDisplayed(true);
            window.scrollTo(0, 0);
            return false;
        }

        drivers.forEach((driver) => {
            disableEditModeIfNonRated(driver);
            cleanUpSpouseIfDriverIsUnmarried(driver);
        });

        if (isReturnToQuote) {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, 'quoteDetails', authHeader);
        }

        const checkDrivers =
        submissionVM?.lobData?.personalAuto?.coverables?.drivers?.children || [];

        const areDriversValid =
        checkDrivers.length > 0 &&
        checkDrivers.every(driver => {
            const aspects = driver?.ageFirstLicensed_ML?.aspects;
            return aspects?.valid === true && aspects?.subtreeValid === true;
        });

        if (!areDriversValid) {
            return false;
        }
        
        return true;
    }, [authHeader, checkUniqueSelf, checkUniqueSpouse, currentStep.mlStepName, disableEditModeIfNonRated, displayNonAccidentPreventionModifierMessage, displayUnobtainableDriverLicenseMessage, driverList, errorTimestamp, goToFirstInvalidTab, isAccidentPreventionCourse, nonAccidentPreventionDisplayed, policyStateCode, selectedDriverVM, submissionVM.lobData.personalAuto.coverables.aspects.subtreeValid, submissionVM.value.lobData.personalAuto.coverables, unobtainableDriverLicense, unobtainableDriverLicenseDisplayed]);

    const returnToQuoteFunction = useCallback( async () => {
        await returnToQuoteScreen(validateData, submissionVM, updateWizardData, history, authHeader);
    }, [authHeader, history, returnToQuoteScreen, submissionVM, updateWizardData, validateData]);

    const next = async () => {

        const isDataValid = await validateData();
        if (!isDataValid) {
            return false;
        }

        if (!isComponentValid) {
            setTimeout(()=>{
                setShowValidtionErrors(true);
                setErrorTimestamp(errorTimestamp+1);
            }, 100);
            return false;
        }

        // clearMVRRequoteFlowAndSkipSave
        MLDisclosureUtil.setRequoteAfterMvr(submissionVM.quoteID.value, false);

        let nextStepName = 'paVehicleDetails';
        const newSubmissionVM = viewModelService.clone(submissionVM);

        if (currentStep.mlStepName === 'compPaDrivers') {
            const isVehiclesStepVisible = steps.find(step => step.mlStepName === 'compPaVehicles');

            nextStepName = isVehiclesStepVisible ? 'compPaVehicles' : 'compPaValidateInfo';

            _.set(newSubmissionVM, 'portalCurrentStep_ML.value', currentStep.mlStepName);
            _.set(newSubmissionVM, 'bypassValidationForComprater_Ext', true);

            // We need to update the submissionVM regardless vehicle page is going to show or not 
            // as data updated in driver page need to pass onto the vehicle page if it is available.
            // Must use async await here otherwise the updated version of submissionVM is not reflected in the next page
            showProgressDialog(platformMessages.saveSubmission);
            try {
                    const res = await LoadSaveService.updateDraftSubmission(newSubmissionVM.value, authHeader);
                    newSubmissionVM.value = res;
                    
                    if (!nextStepVisited()) {
                        if (isVehiclesStepVisible) { 
                            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);
                        }
                    } 

                    updateWizardSnapshot(newSubmissionVM);
                    goNext();
                    //US997118 - Dto validation error on qdd.LobData.PersonalAuto.Coverables.Vehicles
                    return newSubmissionVM;                    
                    
            } finally {
                hideProgressDialog(platformMessages.saveSubmission);
            }
        } else {
            MLMultiLobsDataHolderService.storeFlowSteps(currentStep.mlStepName, nextStepName, authHeader);

            updateWizardSnapshot(newSubmissionVM);
            goNext();
            return false;
        }
    };

    const goToNextTab = () => {
        if (unobtainableDriverLicense(selectedDriverVM.licenseState) && !unobtainableDriverLicenseDisplayed) {
            displayUnobtainableDriverLicenseMessage(false);
            setUnobtainableDriverLicenseDisplayed(true);
            return;
        }

        if (!isComponentValid) {
            setTimeout(()=>{
                setShowValidtionErrors(true);
                setErrorTimestamp(errorTimestamp+1);
            }, 100);
            return;
        }

        const isValid = checkUniqueSelf(driverList) && checkUniqueSpouse(driverList) && selectedDriverVM.aspects.subtreeValid;
        if (isValid && selectedDriverIndex < ratedDriverList.length - 1) {
            const nextIndex = selectedDriverIndex + 1;
            setSelectedDriverIndex(nextIndex);

            setUnobtainableDriverLicenseDisplayed(false);
            clearUnobtainableDriverLicenseMessage();

            window.scrollTo(0, 0);
        }
        if (!isValid) {
            setShowValidtionErrors(true);
            setErrorTimestamp(errorTimestamp+1);
        }
    };

    const checkAndBypassEmptyPhoneNumberForSignalProgram = () => {
        ratedDriverList.forEach((driver) => {
            const modifiersList = driver?.driverModifiers_ML?.modifiers;
            if (Array.isArray(modifiersList)) {
                modifiersList.forEach((modifier) => {
                    if (modifier.codeIdentifier_ML === "PADriverSignalProgramPhoneNumber_Ext") {
                        modifier.isInputValueRequired_ML = false;
                    }
                });
            }
        });
    };

    const checkAndRemoveSchoolAddressIfNotDistantStudent = () => {
        if (isModernProduct) {
            ratedDriverList.forEach((driver) => {
                const modifiersList = driver?.driverModifiers_ML?.modifiers;
                if (Array.isArray(modifiersList)) {
                    modifiersList.forEach((modifier) => {
                        if (modifier.codeIdentifier_ML === 'PADistantStudent_Ext') {
                            if (modifier.chosenTermValue === 'true') {
                                driver.isSchoolAddressRequired_Ext = true;
                            } else {
                                driver.schoolAddress_Ext = undefined;
                                driver.isSchoolAddressRequired_Ext = false;
                            }
                        }
                    });
                }
            });
        }
    };

    const onNext = () => {

        checkAndBypassEmptyPhoneNumberForSignalProgram();
        checkAndRemoveSchoolAddressIfNotDistantStudent();

        if (isGPA) {
            UserService.getCurrentUser(authHeader).then((user) => {
                PATrackEvent('Quote Step Submitted', false, submissionVM, user, { step: 'Drivers Screen', action: 'Drivers Submitted', ratedDriverList: ratedDriverList});
            })
        }
        if (isFinalDriver(selectedDriverVM)) {
            return next();
        }
        goToNextTab();
        return false;
    };

    const onRemoveDriverClick = (evt, driverVM, index) => {
        // stop firing event onDriverTabChange
        evt.stopPropagation();
        _.set(driverVM, 'isPreparedToRemove_ML.value', true);
        _.set(driverVM, 'value.status_ML', null);
        removeDriverButtonClick(driverVM, index);
    };

    const isDistantStudent = (driverVM) => {
        const mods = _.get(driverVM, 'value.driverModifiers_ML.modifiers', []);
        const mod = mods.find((m) => m.codeIdentifier_ML === 'PADistantStudent_Ext');
        return mod?.chosenTermValue === 'true';
    };

    const isDriverValid = (driverVM) => {
        if(!isDistantStudent(driverVM)) {
           _.set(driverVM, 'value.schoolAddress_Ext', null);
        }
        return driverVM.aspects.valid && driverVM.aspects.subtreeValid && isDriverFullNameNonNumeric(_.get(driverVM, 'value')); 
    };

    // Redirect Function
    const handleStepAction = (redirectAction) => {
        if (!_.isEmpty(redirectAction)) {
            if (redirectAction.action === ACTION_ADD_DRIVER) {
                const addID = 'addDriverTabButton';
                onDriverTabChange(addID);
            } else if (redirectAction.action === ACTION_REMOVE_DRIVER) {
                const driverValue = redirectAction.model;
                const driverVMindex = ratedDriverList.findIndex((e) => e.publicID === driverValue.publicID);
                const driverVM = ratedDriverVMList[driverVMindex];
                _.set(driverVM, 'isPreparedToRemove_ML.value', true);
                _.set(driverVM, 'value.status_ML', null);
                removeDriverButtonClick(driverVM, driverVMindex);
            }
        }
    };

    useEffect(() => {
        const stepDataML = _.get(submissionVM, 'value.wizardActionDataML', {});
        if (!_.isEmpty(stepDataML)) {
            handleStepAction(stepDataML);
            _.set(submissionVM, 'value.wizardActionDataML', {});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // End Redirect Functions

    const getTabHeader = (driverVM, index) => {
        const driver = driverVM.value;
        return (
            <div className={styles.tabHeading}>
                <div className="ml-flex-tabs__icon">
                    <i
                        className="icon icon-foremost-account-icon account-icon-left-rail"
                    />
                </div>
                <div className="ml-flex-tabs__text">
                    <p className="ml-flex-tabs__text-header">
                        {driver.person.getDisplayName(' ')}
                    </p>
                </div>
                {!isDriverValid(driverVM) && (
                    <div className="ml-flex-tabs__error">
                        <span className="icon-ml-alert-icon" />
                    </div>
                )}
                {!isOnlyOneDriver() && (
                    <div className="ml-flex-tabs__remove">
                        <span onClick={(evt) => onRemoveDriverClick(evt, driverVM, index)} className="icon-ml-remove-icon" />
                    </div>
                )}
            </div>
        );
    };

    const getAddDriverTabHeading = () => {
        return (
            <Button type="outlined">
                {translator(messages.addDriverButton)}
            </Button>
        );
    };

    const nextStepText_Ext = () => {
        const isFinalDriverRes = isFinalDriver(selectedDriverVM);
        const isCRVehiclesStepVisible = steps.find(step => step.mlStepName === 'compPaVehicles');
        let formattedMessage;

        if (!isFinalDriverRes) {
            formattedMessage = (
                <FormattedMessage
                    {...messages.wellWorkOnYourAdditionalDriversNext}
                    values={{
                        additionalDrivers: (
                            <strong>{translator(messages.additionalDrivers)}</strong>
                        )
                    }}
                />
            );
        } else if (currentStep.mlStepName === 'compPaDrivers' && !isCRVehiclesStepVisible) {
            formattedMessage = (
                <FormattedMessage
                    {...messages.validationNext}
                    values={{
                        validate: (
                            <strong>{translator(messages.validate)}</strong>
                        )
                    }}
                />
            );
        } else {
            formattedMessage = (
                <FormattedMessage
                    {...messages.wellWorkOnYourVehiclesNext}
                    values={{
                        vehicles: (
                            <strong>{translator(messages.vehicles)}</strong>
                        )
                    }}
                />
            );
        }

        return formattedMessage;
    };

    const generateDriversOverrides = () => {
        const driverOverrides = ratedDriverVMList.map((driverVM, index) => {
            return {
                [`${DRIVER_TAB_ID}${index}`]: { heading: getTabHeader(driverVM, index) },
                [`insuredCandidatesComponent${index}`]: {
                    visible: insuredCandidateComponentVisibleML,
                    submissionVM,
                    driverVM,
                    initDriverPublicID: initDriverPublicIDML,
                    setInsuredCandidateSelected: setInsuredCandidateSelectedML,
                    onValueChange: refreshData,
                    viewModelService
                },
                [`driverComponent${index}`]: {
                    visible: insuredCandidateSelectedML,
                    submissionVM,
                    driverVM,
                    driverList: ratedDriverList,
                    showValidtionErrors,
                    handleDriverModelChange: refreshData,
                    updateModifiers,
                    onValidate,
                    updateWizardData
                },
                [`alertsIterable${index}`]: {
                    data: alerts
                },
                [`nonAccidentPreventionWarningContainer${index}`]: {
                    visible: nonAccidentPreventionDisplayed
                },
                [`errorNotification${index}`]: {
                    visible: showValidationError || (showValidationError && insuredCandidateComponentVisibleML && !insuredCandidateSelectedML)
                },
                [`validationErrorMessage${index}`]: {
                    content: validationErrorMessage
                },
            };
        });
        return Object.assign({}, ...driverOverrides);
    };

    const generateAlertsOverrides = () => {
        const alertOverrides = alerts.map((alert, index) => {
            const isError = alert.type === 'error';
            const mainMessage = isError ? <strong>{translator(alert.message)}</strong> : translator(alert.message);

            return {
                [`alert${index}`]: {
                    className: classNames('ml-alert', 'alert', isError ? 'ml-alert-error' : 'ml-alert-success')
                },
                [`statusIcon${index}`]: {
                    className: classNames(isError ? 'icon-ml-alert-icon' : 'icon-ml-status-check-complete icon-green')
                },
                [`alertMessage${index}`]: {
                    content: <FormattedMessage
                        {...messages.alertMessage}
                        values={{
                            object: (
                                alert.object ? <strong>{alert.object}</strong> : undefined
                            ),
                            message: mainMessage
                        }}
                    />
                },
                [`alertTooltip${index}`]: {
                    visible: !_.isEmpty(alert.helpText)
                },
                [`undo${index}`]: {
                    visible: !isError,
                    onClick: alert.undo
                }
            };
        });
        return Object.assign({}, ...alertOverrides);
    };

    const overrideProps = {
        driversIterable: {
            data: ratedDriverList,
            activeTab: activeDriverTab,
            defaultActiveTab: `${DRIVER_TAB_ID}${selectedDriverIndex}driversIterable`
        },
        addDriverTabButton: {
            heading: getAddDriverTabHeading()
        },
        stickyfootercomponent: {
            defaultContinueSectionId: 'footer',
            nextDescription: nextStepText_Ext(),
            onNext,
            showReturnToQuote,
            canRequote,
            returnToQuoteFunction
        },
        nextDescription: {
            content: nextStepText_Ext()
        },
        returnToQuoteButton: {
            visible: showReturnToQuote,
            disabled: !canRequote,
            onClick: returnToQuoteFunction
        },
        ...generateDriversOverrides(),
        ...generateAlertsOverrides()
    };

    const resolvers = {
        resolveCallbackMap: {
            onNext,
            onValidate,
            onDriverTabChange
        },
        resolveClassNameMap: styles,
        resolveComponentMap: {
            mlInsuredCandidatesComponent: MLInsuredCandidatesComponent,
            mlpaeditdrivercomponent: MLPAEditDriverComponent,
            tooltipcomponent: MetadataTooltip
        }
    };

    const updateDriverModifier = () => {
        const drivers = _.get(submissionVM, 'lobData.personalAuto.coverables.drivers.value', []);
        drivers.forEach((driver) => {
            const modifiers = _.get(driver, 'driverModifiers_ML.modifiers', []);
            modifiers.filter((mod) => mod.codeIdentifier_ML === 'PADriverSignalProgramPhoneNumber_Ext')
                .forEach((mod) => {
                    _.defaults(mod, { chosenTermValue: null });
                    _.set(mod, 'isInputValueRequired_ML', false);
                });
        });
        _.set(submissionVM, 'lobData.personalAuto.coverables.drivers.value', drivers);
        updateWizardData(submissionVM);
    }

    const skipOnResumeIf = () => {
        
        updateDriverModifier();

        const jumpToQuote = _.get(history, 'location.state.jumpToQuote', false)

        if (jumpToQuote) {
            return initialValidation().then((isValid) => !!isValid);
        } else {
            checkAndBypassEmptyPhoneNumberForSignalProgram()

            if (submissionVM.lobData.personalAuto.coverables.drivers && (
                submissionVM.lobData.personalAuto.coverables.drivers.aspects.valid !== true ||
                submissionVM.lobData.personalAuto.coverables.drivers.aspects.subtreeValid !== true
            )) {
                console.log('Stopping on Drivers Page becuase drivers are not valid');
                return false;
            }
            
            if (currentStep?.mlStepName === 'compPaDrivers') {
                const lastVisitedStep = MLMultiLobsDataHolderService.getLastVisitedStep();
                const lastVisitedStepFound = steps.find(step => step.mlStepName === lastVisitedStep);

                return MLMultiLobsDataHolderService.hasCompletedStep('compPaDrivers') && lastVisitedStepFound;
            }

            if (!!_.get(submissionVM, 'bindData.policyNumber.value')
                && (submissionVM.value.baseData.status_ML === 'Bound' || submissionVM.value.baseData.status_ML === 'Binding')) {
                return true;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'paDriverDetails') {
                console.log('stopping on drivers page because lastVisitedStep is paDriverDetails');
                return false;
            }

            if (MLMultiLobsDataHolderService.getLastVisitedStep() === 'quoteDetails' &&
                submissionVM.hvqQuoteID_ML.value &&
                submissionVM.isBundle_ML.value) {
                return true;
            }

            if (submissionVM.isBundle_ML.value
                && submissionVM.value.baseData.status_ML !== 'Draft') {
                return true;
            }
                
            console.log('Skipping Drivers Page because drivers are valid');
            return true;
        }
    };

    const handleValueChange = () => {
        updateWizardData(submissionVM);
    }

    return (
        <WizardPage
            showCancel={false}
            showPrevious={false}
            skipWhen={skipOnResumeIf}
            showNext={!nextStepVisited() && isFinalDriver(selectedDriverVM)}
            onNext={onNext}
            nextLabel={translator(platformMessages.mlContinue)}
            showTextNextToButton={!nextStepVisited() && isFinalDriver(selectedDriverVM)}
            textNextToButton={nextStepText_Ext()}
            metadataPageId={!nextStepVisited() && isFinalDriver(selectedDriverVM) && _.get(metadata, 'pageContent.id')}
            showReturnToQuote={showReturnToQuote && isFinalDriver() && canRequote}
            disableReturnToQuote={!canRequote}
            updateWizardData={updateWizardData}
            history={history}
            validateData={validateData}
        >
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                callbackMap={resolvers.resolveCallbackMap}
                classNameMap={resolvers.resolveClassNameMap}
                componentMap={resolvers.resolveComponentMap}
                showErrors={showValidtionErrors}
                onValueChange={handleValueChange}
            />
            <ScrollToError counter={errorTimestamp} />
        </WizardPage>
    );
}

GatewayDriversPage.propTypes = wizardProps;
export default withRouter(GatewayDriversPage);